<template>
  <v-container class="alert-pop">
    <v-snackbar
      v-model="showStatus"
      timeout="-1"
      :color="msgColor"
      top
      right
      transition="slide-x-reverse-transition"
      width="350"
      max-width="350"
      min-width="300"
      absolute
    >
      <div class="d-flex align-center text-subtitle-1">
        <v-icon class="mr-2" color="white" v-if="msgIcon">{{ msgIcon }}</v-icon>
        {{ $t(text) }}
      </div>
      <template #action="{ attrs }" v-if="allowClose">
        <v-btn color="white" icon v-bind="attrs" @click="closeAlertBox()">
          <v-icon class="fi fi-rr-cross-small"></v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mdiAlertOctagon, mdiCheckCircle, mdiInformation, mdiAlert } from '@mdi/js'
export default {
  name: 'Snack',
  props: ['type', 'show', 'text', 'allowClose', 'timeout'],
  data: () => ({
    showStatus: false,
    timeOutClock: null,
  }),
  watch: {
    show: function(newVal) {
      this.showStatus = newVal
      if (newVal) {
        if (this.timeOutClock != null) {
          clearTimeout(this.timeOutClock)
        }

        this.timeOutClock = setTimeout(() => {
          this.closeAlertBox()
        }, this.timeout * 1000)
      }
    },
  },
  computed: {
    msgIcon() {
      switch (this.type) {
        case 'success':
          return mdiCheckCircle
        case 'info':
          return mdiInformation
        case 'warning':
          return mdiAlert
        case 'error':
          return mdiAlertOctagon
        default:
          return ''
      }
    },
    msgColor() {
      return this.type
    },
  },
  methods: {
    async closeAlertBox() {
      clearTimeout(this.timeOutClock)
      this.timeOutClock = null
      this.$store.dispatch('setLoading', false)

      let redirect = null
      if (this.$store.getters.snackMessage.refresh) {
        window.scrollTo(0, 0)
        this.$router.go()
      } else if (this.$validate.DataValid(this.$store.getters.snackMessage.redirect)) {
        if (typeof this.$store.getters.snackMessage.redirect === 'string') {
          redirect = { name: this.$store.getters.snackMessage.redirect }
        } else {
          redirect = this.$store.getters.snackMessage.redirect
        }
      }

      if (redirect) {
        if (redirect.name === 'Login' || redirect.name === 'StudentLogin') {
          const getUser = this.gfGetCurrentUserData()
          if (getUser && getUser.user_type === 'student') {
            redirect['name'] = 'StudentLogin'
            redirect['params'] = { username: getUser.username }
          } else {
            redirect['name'] = 'Login'
          }
          await this.gfRemoveUserCookies()
        }
        this.$router.replace(redirect)
      }

      this.$store.dispatch('toggleSnack')
      if (this.$store.getters.showOverlay) {
        this.$store.dispatch('toggleOverlay')
      }
      if (this.$store.getters.showLoadingPage) {
        this.$store.dispatch('toggleLoadingPage')
      }
    },
  },
  beforeDestroy() {
    if (this.timeOutClock != null) {
      clearTimeout(this.timeOutClock)
    }
  },
}
</script>
